// OwnerGate
// ---------
// Stricter cousin of RoleGate: the wrapped route is reachable only by
// users in the Account Owner role (CLIENT_OWNER_GROUP). RoleGate
// allows both Sys Admin and Account Owner; OwnerGate is the
// owner-singleton.
//
// Used for routes that touch billing / plan ownership — actions
// where a tenant's Sys Admin should be able to view (via Usage page)
// but only the Account Owner can mutate (via Billing page).
//
// Behavior follows RoleGate verbatim:
//   - User hydrated AND not the Account Owner → redirect to Dashboard.
//   - User not yet hydrated (role === [])     → render <Outlet/>; the
//                                                 wrapped page handles
//                                                 its own loading.
//   - User hydrated AND Account Owner         → render <Outlet/>.
//
// Defense-in-depth: BE remains the authoritative authz boundary; this
// just prevents URL-typing past the nav-level gating.

import { Navigate, Outlet } from "react-router-dom";
import { DASHBOARD_PAGE } from "../constants/definitions";
import UserClass from "../models/user";

interface OwnerGateProps {
  user: UserClass;
}

export function OwnerGate({ user }: OwnerGateProps) {
  const userIsHydrated = user.role.length > 0;
  if (userIsHydrated && !user.isAccountOwner()) {
    return <Navigate to={DASHBOARD_PAGE} replace />;
  }
  return <Outlet />;
}

export default OwnerGate;
